const mobileTrigger = document.getElementById("js-mobile-trigger");
const searchTrigger = document.getElementById("js-search-trigger");
const siteHeader = document.querySelector(".site-header");
const searchInput = siteHeader.querySelector(".search-field");

function toggleAriaExpanded(el, focusEl = null) {
  const expanded = el.getAttribute("aria-expanded") === "true" ? true : false;
  el.setAttribute("aria-expanded", !expanded);

  if (!expanded && focusEl) focusEl.focus();
}

if (mobileTrigger) {
  mobileTrigger.addEventListener("click", (e) => {
    e.preventDefault();
    siteHeader.classList.remove("search-active");

    mobileTrigger.classList.toggle("active");
    siteHeader.classList.toggle("menu-active");
    toggleAriaExpanded(
      mobileTrigger,
      document.querySelector("#menu-mobile-menu a")
    );
  });
}

if (searchTrigger) {
  searchTrigger.addEventListener("click", (e) => {
    e.preventDefault();
    siteHeader.classList.remove("menu-active");

    searchTrigger.classList.toggle("active");
    siteHeader.classList.toggle("search-active");
    toggleAriaExpanded(searchTrigger, searchInput);
  });
}
